<template>
  <DatePickerISOCompliant
    :key="field.value"
    :clearable="!field.isReadOnly && !disabled && !field.isRequired"
    :disabled="disabled"
    :readonly="field.isReadOnly"
    :label="labelText"
    v-model="field.value"
    :maxlength="field.validations.maxLength"
    :counter="field.validations.maxLength"
    :hint="field.observations"
    :error-messages="fieldErrors"
    @change="onChange"
    @input="validator.document.fields.$each[index].value.$touch()"
    @blur="validator.document.fields.$each[index].value.$touch()"
  />
</template>
<script>
import { EventBus } from "@/eventBus.js";
import DatePickerISOCompliant from "@/components/base/DatePickerISOCompliant";
export default {
  components: {
    DatePickerISOCompliant,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
    },
    ctIndex: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fieldChangeSource: {
      type: Number,
      default: 0
    }
  },
  computed: {
    labelText() {
      return `${this.field.title}${this.field.isRequired ? " *" : ""}`;
    },
    fieldErrors() {
      const errors = [];
      if (this.validator.document) {
        if (!this.validator.document.fields.$each[this.index].value.$dirty)
          return errors;
        !this.validator.document.fields.$each[this.index].value.required &&
          errors.push(this.$t("RequiredField"));
      } else if (this.validator.contentTypeList) {
        if (
          !this.validator.contentTypeList.$each[this.ctIndex].document.fields
            .$each[this.index].value.$dirty
        )
          return errors;
        !this.validator.contentTypeList.$each[this.ctIndex].document.fields
          .$each[this.index].value.required &&
          errors.push(this.$t("RequiredField"));
      }
      return errors;
    },
  },
  methods: {
    onChange() {
      EventBus.$emit("field-edited", this.field, this.fieldChangeSource);

      this.field.valueDate = new Date(this.field.value);
    },
  },
};
</script>
